/**
 * API 配置管理 - 業界最佳實踐
 * 統一管理所有 API 相關配置
 * 
 * 架構說明:
 * - 前端: 部署在 Cloudflare Pages (xxxmemo.com)
 * - 後端: 部署在 Zeabur (https://xxxmemo-bk.zeabur.app)
 */

// API 基礎配置
export const API_CONFIG = {
  // 基礎 URL（不包含版本路徑）
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://xxxmemo-bk.zeabur.app',
  
  // API 版本
  VERSION: process.env.REACT_APP_API_VERSION || 'api',
  
  // 完整的 API URL
  get FULL_URL() {
    return `${this.BASE_URL}/${this.VERSION}`;
  },
  
  // 請求超時時間
  TIMEOUT: 10000,
  
  // 重試配置
  RETRY: {
    attempts: 3,
    delay: 1000,
  },
};

// API 端點配置
export const API_ENDPOINTS = {
  // 認證相關
  AUTH: {
    LOGIN: '/token/',
    REFRESH: '/token/refresh/',
    LOGOUT: '/logout/',
    USER: '/users/me/',                    // 修正：用戶詳情端點
    PERMISSIONS: '/users/permissions/',    // 修正：權限檢查端點
  },
  
  // 內容相關
  CONTENT: {
    TOPICS: '/topics/',
    POSTS: '/posts/',
    POSTS_BY_TOPIC: (topicId) => `/posts/topics/${topicId}/`,
    POST_DETAIL: (postId) => `/posts/${postId}/`,
    COMMENTS: '/comments/',
    COMMENTS_BY_POST: (postId) => `/posts/${postId}/comments/`,
    ADS: '/ads/',
    HOT_POSTS: '/posts/hot/',
  },
  
  // 用戶相關
  USER: {
    PROFILE: '/users/me/',
    POSTS: '/users/me/posts/',
    REGISTER: '/users/register/',
    POSTS_BY_USER: (username) => `/users/${username}/`,
  },
  
  // 管理相關
  ADMIN: {
    USERS: '/users/admin/users/',
    STATS: '/admin/stats/',
    MODERATORS: '/moderators/',
    TOPIC_STATS: '/admin/topic-stats/',
  },
  
  // 文件上傳
  UPLOAD: {
    IMAGE: '/upload/image/',
    AVATAR: '/users/upload/avatar/',
  },
};

// HTTP 狀態碼常數
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};

// 錯誤訊息映射
export const ERROR_MESSAGES = {
  NETWORK_ERROR: '網絡連接失敗，請檢查您的網絡設置',
  UNAUTHORIZED: '登錄已過期，請重新登錄',
  FORBIDDEN: '您沒有執行此操作的權限',
  NOT_FOUND: '請求的資源不存在',
  SERVER_ERROR: '服務器錯誤，請稍後再試',
  UNKNOWN_ERROR: '發生未知錯誤，請聯繫技術支持',
};


export const MEDIA_LIMITS = {
  POST_IMAGE_MAX_MB: Number(process.env.REACT_APP_POST_IMAGE_MAX_MB || '15'),
};

export default API_CONFIG;
